import 'css-chunksrc/client/pages/taskPage/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_1ltrg_1",
  "dates": "_dates_1ltrg_6",
  "row": "_row_1ltrg_10",
  "date": "_date_1ltrg_6"
};